import locationsReducer from "./locationsSlice";
import locationReducer from "./locationSlice";

const locations = {
  locations: locationsReducer,
  location: locationReducer,
};

export default locations;
